import { ReactNode, useMemo } from 'react';
import { calculateDisplayValue, calculateTooltipValue } from '../../FieldFilter.utils';
import { useFilterContext } from '../FilterContext';

interface UseFieldFilterDisplayParams {
  filterObject: any;
  mode: string;
  isDateField: boolean;
  valueOperator: string;
  value: any;
  operator: string;
  calcOptions: Array<{ value: any; title: string }>;
  conditionValue: any;
  getValue: ((v: any) => ReactNode) | undefined;
}

export const useFieldFilterDisplay = ({
  filterObject,
  mode,
  isDateField,
  valueOperator,
  value,
  operator,
  calcOptions,
  conditionValue,
  getValue,
}: UseFieldFilterDisplayParams) => {
  const { measurements } = useFilterContext();
  const tooltipValue = useMemo(
    () =>
      calculateTooltipValue({
        filterObject,
        mode,
        isDateField,
        valueOperator,
        value,
        operator,
        calcOptions,
      }),
    [value, conditionValue, filterObject, operator, mode, isDateField, valueOperator, calcOptions]
  );

  const displayValue = useMemo(
    () =>
      calculateDisplayValue({
        filterObject,
        isDateField,
        valueOperator,
        value,
        getValue,
        calcOptions,
        measurementsAsObject: measurements.asObject,
      }),
    [value, conditionValue, filterObject, operator, getValue, isDateField, valueOperator, calcOptions, measurements.asObject]
  );

  return { tooltipValue, displayValue };
};
